import { Component } from '@angular/core';
import { BreadcrumbService } from './breadcrumb.service';

@Component({
	selector: 'app-breadcrumb',
	templateUrl: 'breadcrumb.template.html'
})

/**
 * BreadcrumbComponent is the component for the sites' breadcrumb element
 */
export class BreadcrumbComponent
{
	/**
	 * BreadcrumbComponent constructor
	 *
	 * @param {BreadcrumbService} breadcrumbService
	 */
	constructor(private breadcrumbService: BreadcrumbService)
	{
	}
}



// WEBPACK FOOTER //
// ./src/app/breadcrumb/breadcrumb.component.ts